import { Component, Input} from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-checkbox-group',
    templateUrl: './checkbox-group.component.html',
    styleUrls: ['./checkbox-group.component.scss'],
    standalone: false
})
export class CheckboxGroupComponent {

  list: { value: string | number; text: string }[];
  control: FormControl;
  keys: any;
  log: any;

  @Input('control') set _control(value: any) {
    this.control = value as FormControl;
  }
  @Input('source') set _source(value: any[]) {
    const type = typeof value[0];
    if (type == 'string' || type == 'number')
      this.list = value.map((x) => ({ value: x, text: '' + x }));
    else {
      const match = [
        ...JSON.stringify(value[0])
          .replace(/\"/g, '')
          .matchAll(/(\w+)\:[^,]*/g),
      ].map((x) => x[1]);
      this.list = value.map((x) => ({ value: x[match[1]], text: x[match[2]] }));
    }
  }

  update(checked: boolean, value: string | number) {
    const oldValue = this.control.value || [];
    if (!checked)
      this.control.setValue(
        oldValue.filter((x: string | number) => x != value)
      );
    else
      this.control.setValue(
        this.list
          .filter(
            (x: any) => x.value == value || oldValue.indexOf(x.value) >= 0
          )
          .map((x) => x.value)
      );
  }

}
